export const isActiveDocumentElement = (element: HTMLElement) =>
  document.activeElement === element;
